import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "@/assets/font/font.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Toast from "@/plugins/toast";

import Common from "@/lib/common";
import ApiClient from "@/lib/apiClient";

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID || "G-441ZJEY7H3" },
});

import ECharts from "vue-echarts";
import { use } from "echarts/core";
// import ECharts modules manually to reduce bundle size
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart, PieChart, MapChart } from "echarts/charts";
import { LegendComponent, TitleComponent, GridComponent, TooltipComponent } from "echarts/components";

use([LegendComponent, TitleComponent, CanvasRenderer, LineChart, BarChart, PieChart, MapChart, GridComponent, TooltipComponent]);

// import VueQrcodeReader from "vue-qrcode-reader";
// Vue.use(VueQrcodeReader);

// import * as echarts from "echarts";
// Vue.prototype.$echarts = echarts;

// import "echarts/lib/chart/map";
// import "echarts/lib/chart/line";
// import "echarts/lib/chart/gauge";
// import "echarts/lib/component/title";
// import "echarts/lib/component/tooltip";
// import "echarts/lib/component/legend";
// import "echarts/lib/component/dataZoom";
Vue.component("v-chart", ECharts);

Vue.use(VueSweetalert2);
Vue.use(Toast);

Vue.config.productionTip = false;

function resolveCommunityServiceUrl() {
  if (process.env.VUE_APP_SERVICE_URL) return process.env.VUE_APP_SERVICE_URL;
  if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "prod") return "https://api.nestbutler.com.tw";
  const hostname = window.location.hostname || "localhost";
  return `http://${hostname}:8888`;
}

function resolveDeveloperName() {
  if (process.env.VUE_APP_DEVELOPER_NAME) return process.env.VUE_APP_DEVELOPER_NAME;
  const hostname = window.location.hostname || "";
  if (hostname === "myhomi.com.tw" || hostname.endsWith(".myhomi.com.tw")) return "永雋科技股份有限公司";
  return "凌雲智能股份有限公司";
}

Vue.prototype.$serviceUrl = resolveCommunityServiceUrl();
Vue.prototype.$api = new ApiClient(Vue.prototype.$serviceUrl);

// WebSocket / WebRTC 配置
Vue.prototype.$wsUrl = process.env.VUE_APP_WS_URL || "wss://ws.nestbutler.com.tw";
Vue.prototype.$turnUDP = process.env.VUE_APP_TURN_UDP || "turn:turn.nestbutler.com.tw:3478?transport=udp";
Vue.prototype.$turnTCP = process.env.VUE_APP_TURN_TCP || "turn:turn.nestbutler.com.tw:3478?transport=tcp";
Vue.prototype.$iceUsername = process.env.VUE_APP_ICE_USERNAME || "";
Vue.prototype.$iceCredential = process.env.VUE_APP_ICE_CREDENTIAL || "";

// 品牌 / 聯絡資訊
Vue.prototype.$brandName = process.env.VUE_APP_BRAND_NAME || "大華雲管家";
Vue.prototype.$mgmtAppName = process.env.VUE_APP_MGMT_APP_NAME || "大華雲管家管理版APP";
Vue.prototype.$residentAppName = process.env.VUE_APP_RESIDENT_APP_NAME || "大華雲管家APP";
Vue.prototype.$contactEmail = process.env.VUE_APP_CONTACT_EMAIL || "admin@lyncloud.com.tw";
Vue.prototype.$developerName = resolveDeveloperName();

router.beforeEach((to, from, next) => {
  if (!store.getters.getToken) {
    let token = window.localStorage.getItem("jwttoken");
    if (token) store.commit("login", token);
  }

  // if (!store.getters.getMenuStatus) {
  //   let menuStatus = window.sessionStorage.getItem("menuStatus");
  //   if (menuStatus) store.commit("setMenuStatus", JSON.parse(menuStatus));
  // }

  if (!store.getters.getSelectCommunity) {
    let selectCommunity = window.localStorage.getItem("selectCommunity");
    if (selectCommunity) store.commit("setSelectCommunity", JSON.parse(selectCommunity));
  }

  if (!store.getters.getUser) {
    let userData = window.localStorage.getItem("userData");
    if (userData) store.commit("setUser", JSON.parse(userData));
  }

  // if (!store.getters.getToken) {
  //   if (to.name !== "Login" && to.name !== "AccountLogin" && to.name !== "QRCodeLogin" && to.name !== "ScanLogin" && to.name !== "Register") {
  //     next({ name: "Login" });
  //     return;
  //   }
  // } else if (
  //   store.getters.getToken &&
  //   (to.name == "Login" || to.name == "AccountLogin" || to.name == "QRCodeLogin" || to.name == "ScanLogin" || to.name == "Register")
  // ) {
  //   if (store.getters.isAdmin) {
  //     next({ name: "AdminDashboard" });
  //     return;
  //   } else {
  //     next({ name: "MainScreen" });
  //     return;
  //   }
  // }
  if (to.meta.auth && !store.getters.getToken) {
    next({ name: "Login" });
    return;
  } else if (to.meta.auth && !store.getters.getSelectCommunity) {
    next({ name: "Login" });
    return;
  }

  // if (!store.getters.getSelectCommunity) {
  //   next({ name: "Login" });
  //   return;
  // }

  const matchedMetas = to.matched.map((record) => record.meta || {});
  for (const meta of matchedMetas) {
    if (!meta.module) continue;
    const community = store.getters.getSelectCommunity;
    const isFindModule = community.Module && Array.isArray(community.Module) && community.Module.some((m) => m.Name === meta.module);
    if (!isFindModule) {
      next({ name: "Menu" });
      return;
    }
  }

  for (const meta of matchedMetas) {
    const requiredFunctions = meta.functions || (meta.function ? [meta.function] : []);
    if (!requiredFunctions.length) continue;
    const userFunctions = store.getters.getSelectCommunity.Function || [];
    const isFindFunction = requiredFunctions.some((functionName) => userFunctions.includes(functionName));
    if (!isFindFunction) {
      next({ name: "Menu" });
      return;
    }
  }

  // } else if (!to.meta.admin && store.getters.isAdmin) {
  //   next({ name: "AdminDashboard" });
  //   return;
  // }
  next();
});

const VueInstance = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

Vue.prototype.$common = new Common(VueInstance);

// 跨分頁登出同步
window.addEventListener("storage", (event) => {
  if (event.key === "jwttoken" && !event.newValue) {
    store.commit("logout");
    router.push({ name: "Login" }).catch(() => {});
  }
});

// Axios 自動加入JWT認證
axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    if (store.state.jwttoken) {
      config.headers["Authorization"] = `Bearer ${store.getters.getToken}`;
    }
    config.withCredentials = true;
    return config;
  },
  (err) => {
    return Promise.resolve(err.response);
  },
);

// 異常處理
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (!err || !err.response) return Promise.reject(err);
    if (err && err.response) {
      switch (err.response.status) {
        case 444:
          console.log("登入逾時");
          store.commit("logout");
          alert("登入逾時，請重新登入");
          router.push({ name: "Login" }).catch(() => {});
          break;

        case 401:
          if (err.response.data?.Code === "reauth_required") {
            console.log("TSM 二次驗證需求");
            break;
          }
          console.log("401 權限不足");
          break;
        case 404:
          console.log("404 找不到該頁面");
          break;
        case 500:
          console.log("500 伺服器出錯");
          break;
        case 503:
          console.log("503 服務失效");
          break;
        default:
          console.log(`連接錯誤 Code:${err.response.status} `);
      }
    }
    return Promise.resolve(err.response);
  },
);
